import React, { useState, useContext, useEffect } from 'react'


import './FillGaps.css'

const answers = ['Спутник планеты Земля - ', 'Солнце - это ', 'another item text']


const FillGapsResult = ({ question }) => {
    const [textsArray, setTextsArray] = useState([])
    const [questionProcessed, setQuestionProcessed] = useState([])
    const [answerIndex, setAnswerIndex] = useState(0)
    const countSelectedAnswers = (answers) => {
        return answers.reduce((count, answer) => {
            if (answer.selected) {
                count.trueCount += 1;
            } else {
                count.falseCount += 1;
            }
            return count;
        }, { trueCount: 0, falseCount: 0 });
    }

    const selectedCounts = countSelectedAnswers(question.answers);
    // console.log(question)

    // console.log(currentAnswer)
    // useEffect(() => {
    //     const arrayText = question.text.split(/<[0-9]>/).map(function (item) {
    //         return item.trim();
    //     }).filter(item => item !== '');

    //     // console.log(arrayText)
    //     setQuestionProcessed(arrayText)
    // }, []);


    // console.log(question)
    useEffect(() => {
        const arrayText = question.text.split(' ').map(function (item) {
            // console.log(item)
            return item.trim();
        }).filter(item => item !== '');

        console.log(arrayText)
        setQuestionProcessed(arrayText)
    }, [question]);
let int = 0
    const getAnswerIndex = (int) => {
        console.log(int)
        console.log(question.answers[int], question.answers)
        console.log(int)

		int = int -1;
        return <div className='fillGaps__input' style={{ border: question.answers[int]?.selected ? '1px solid #22C532' : '1px solid #FF0000' }} >{question.answers[int]?.text}</div>
    }

console.log(questionProcessed)
    return (<div className='fillGaps__container_wrap'>
                <div className='fillGaps__container'>
                    {/* {questionProcessed &&
                        questionProcessed.map((line, index) => (
                            line !== '' &&
                            <div className='fillGaps__item' key={index}>
                                <p className='fillGaps__text'>{line}</p>
                                <div className='fillGaps__input' style={{borderColor: question.answers[index].selected? '#0F9918' : '#E54545'}} type='text' >{question.answers[index].text}</div>
                            </div>
                        ))} */}

                    {questionProcessed &&
                        questionProcessed.map((line, index) => (
                            line !== '' &&
                            <div className='fillGaps__item' key={index}>
                                {!/<[0-9]>/.test(line) && <p className='fillGaps__text'>{line}</p>}
                                {/<[0-9]>/.test(line) &&
                                getAnswerIndex(line.replace(/\D/g,''))
                                }
                                
                            </div>
                        ))}

                </div>
                <div className='fillGaps__answerCount'>
                    <div className='fillGaps__answerCorrect'>Правильных ответов: {selectedCounts.trueCount}</div>
                    <div className='fillGaps__answerWrong'>Ошибок: {selectedCounts.falseCount}</div> 
                </div>
        </div>
    )

}

export default FillGapsResult